import React, { useState } from "react";
import { supabase } from "../supabaseClient";
import { useNavigate } from "react-router-dom";

const EmailPasswordLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    const { error: loginError } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (loginError) {
      setError(loginError.message);
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <div className="min-h-screen w-screen overflow-x-hidden bg-gradient-to-br from-[#020617] via-[#050816] to-black font-inter text-slate-100 flex flex-col">
      {/* Top mini-nav */}
      <header className="w-full max-w-5xl mx-auto flex items-center justify-between px-4 pt-4 pb-2">
        <div className="flex items-center gap-2">
          <img
            src="/Dreamframelogo.png"
            alt="Dreamframe Studio Logo"
            className="h-8 w-8 rounded-md shadow-[0_0_16px_rgba(124,58,237,0.6)] object-cover"
          />
          <span className="text-sm font-semibold tracking-wide text-cyan-200">
            Dreamframe Studio
          </span>
        </div>
        <button
          type="button"
          onClick={() => navigate("/")}
          className="rounded-2xl border border-slate-500/70 bg-slate-900/80 px-3 py-1.5 text-xs font-medium text-slate-100 hover:bg-slate-800 hover:border-cyan-300/70"
        >
          ← Back to main site
        </button>
      </header>

      {/* Centered auth card */}
      <div className="flex-1 w-full flex justify-center items-center pt-10 pb-24 md:pt-6 md:pb-24 box-border px-4">
        <form
          onSubmit={handleLogin}
          className="w-full max-w-md rounded-3xl border border-white/10 bg-slate-900/95 px-6 py-7 shadow-[0_18px_45px_rgba(0,0,0,0.85)] backdrop-blur flex flex-col gap-4"
        >
          {/* Logo */}
          <div className="flex flex-col items-center mb-1">
            <img
              src="/Dreamframelogo.png"
              alt="Dreamframe Studio Logo"
              className="h-16 w-16 rounded-xl object-cover shadow-[0_0_30px_rgba(129,140,248,0.7)] mb-3"
            />
            <h2 className="text-lg font-semibold text-sky-200 text-center">
              🔐 Login with Email + Password
            </h2>
            <p className="mt-1 text-[11px] text-slate-400 text-center">
              Use your email and password to access the Collab Hub. You can
              always switch back to magic-link or Google login.
            </p>
          </div>

          {/* Email */}
          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-slate-200">
              Email address
            </label>
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-xl border border-slate-600 bg-slate-950/70 px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:border-cyan-400 focus:outline-none"
              required
            />
          </div>

          {/* Password */}
          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-slate-200">
              Password
            </label>
            <input
              type="password"
              placeholder="Your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-xl border border-slate-600 bg-slate-950/70 px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:border-cyan-400 focus:outline-none"
              required
            />
          </div>

          {/* Error message */}
          {error && (
            <p className="mt-1 text-[12px] text-rose-400 text-center">
              {error}
            </p>
          )}

          {/* Submit */}
          <button
            type="submit"
            className="mt-2 w-full rounded-2xl bg-gradient-to-r from-indigo-500 via-fuchsia-500 to-pink-500 px-4 py-2.5 text-sm font-semibold text-white shadow-md shadow-fuchsia-500/40 hover:brightness-110"
          >
            Login
          </button>

          {/* Back to other login options */}
          <p className="mt-3 text-center text-[12px] text-slate-300">
            Prefer a magic link or Google?
            <button
              type="button"
              onClick={() => navigate("/login")}
              className="ml-1 text-cyan-300 underline underline-offset-4 hover:text-cyan-200"
            >
              🔄 Use other login options
            </button>
          </p>
        </form>
      </div>

      {/* Floating footer pill */}
      <footer className="fixed bottom-4 left-1/2 -translate-x-1/2 rounded-full border border-white/10 bg-slate-900/80 px-4 py-1.5 text-[11px] text-slate-400 shadow-[0_0_12px_rgba(127,0,255,0.25)] backdrop-blur z-[1000]">
        © {new Date().getFullYear()} Dreamframe Studio. All rights reserved.
      </footer>
    </div>
  );
};

export default EmailPasswordLogin;
